module.exports = __webpack_public_path__ + "static/media/facebook_reaction_like.5f09142e.svg";